import React from 'react';

import { SkeletonBlock, SkeletonOverlay } from 'components/shared';

const SECTION_COUNT = 3;
const DISH_COUNT = 3;

const row: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 16 };

export default function MenuDetailsSkeleton({ isLoading }: { isLoading: boolean }) {
    return (
        <SkeletonOverlay isLoading={isLoading} style={{ padding: '16px 24px', gap: 12 }}>
            <div style={{ ...row, height: 54 }}>
                <SkeletonBlock height={24} width={24} />
                <SkeletonBlock height={24} width={240} />
                <div style={{ flexGrow: 1 }} />
                <SkeletonBlock height={36} width={140} />
                <SkeletonBlock height={24} width={24} />
            </div>
            {Array.from({ length: SECTION_COUNT }, (_, section) => (
                <React.Fragment key={section}>
                    <SkeletonBlock height={40} style={{ marginTop: 8 }} />
                    {Array.from({ length: DISH_COUNT }, (_, dish) => (
                        <div key={dish} style={{ ...row, height: 64, paddingLeft: 16 }}>
                            <SkeletonBlock height={48} width={48} />
                            <SkeletonBlock height={20} style={{ flexShrink: 1 }} />
                            <SkeletonBlock height={20} width={80} />
                        </div>
                    ))}
                </React.Fragment>
            ))}
        </SkeletonOverlay>
    );
}
